// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BusinessInformation_businessInformationContainer__ubZEQ {
  width: 100%;
  height: 450px;
}

.BusinessInformation_businessInformationFormContainer__Z1S6J {
  height: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BusinessInformation_businessInformationInput__07nIr {
  max-width: 370px;
  height: 56px;
}

.BusinessInformation_businessInformationRightFormContainer__J\\+\\+Tm {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.BusinessInformation_businessInformationInputPasswordField__fL99I {
  margin-bottom: 50px;
}

.BusinessInformation_businessImgage__Ksq18 {
  margin-top: 20px;
  width: 370px;
}

.BusinessInformation_formContainer__FKvY5 {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
}
.BusinessInformation_requiredTag__yRvvi {
  text-align: right;
}

.BusinessInformation_requiredRed__jGmX\\+ {
  color: var(--color-font-red);
}

.BusinessInformation_businessInformationLeftFormContainer__oSRaa {
  width: 100%;
  height: 430px;
  display: flex;
  flex-direction: column;
}

.BusinessInformation_businessInformationDropdown__ZPOKp {
  width: 370px !important;
  margin-bottom: 25px;
}

.BusinessInformation_doubleInput__QjDwR {
  width: 370px;
  display: flex;
  justify-content: space-between;
}
.BusinessInformation_businessInformationCopy__fJ8CJ {
  font-size: 16px !important;
}

`, "",{"version":3,"sources":["webpack://./src/@_pages/AccountCreation/components/BusinessInformation/BusinessInformation.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".businessInformationContainer {\n  width: 100%;\n  height: 450px;\n}\n\n.businessInformationFormContainer {\n  height: 400px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.businessInformationInput {\n  max-width: 370px;\n  height: 56px;\n}\n\n.businessInformationRightFormContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.businessInformationInputPasswordField {\n  margin-bottom: 50px;\n}\n\n.businessImgage {\n  margin-top: 20px;\n  width: 370px;\n}\n\n.formContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  width: 100%;\n}\n.requiredTag {\n  text-align: right;\n}\n\n.requiredRed {\n  color: var(--color-font-red);\n}\n\n.businessInformationLeftFormContainer {\n  width: 100%;\n  height: 430px;\n  display: flex;\n  flex-direction: column;\n}\n\n.businessInformationDropdown {\n  width: 370px !important;\n  margin-bottom: 25px;\n}\n\n.doubleInput {\n  width: 370px;\n  display: flex;\n  justify-content: space-between;\n}\n.businessInformationCopy {\n  font-size: 16px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"businessInformationContainer": `BusinessInformation_businessInformationContainer__ubZEQ`,
	"businessInformationFormContainer": `BusinessInformation_businessInformationFormContainer__Z1S6J`,
	"businessInformationInput": `BusinessInformation_businessInformationInput__07nIr`,
	"businessInformationRightFormContainer": `BusinessInformation_businessInformationRightFormContainer__J++Tm`,
	"businessInformationInputPasswordField": `BusinessInformation_businessInformationInputPasswordField__fL99I`,
	"businessImgage": `BusinessInformation_businessImgage__Ksq18`,
	"formContainer": `BusinessInformation_formContainer__FKvY5`,
	"requiredTag": `BusinessInformation_requiredTag__yRvvi`,
	"requiredRed": `BusinessInformation_requiredRed__jGmX+`,
	"businessInformationLeftFormContainer": `BusinessInformation_businessInformationLeftFormContainer__oSRaa`,
	"businessInformationDropdown": `BusinessInformation_businessInformationDropdown__ZPOKp`,
	"doubleInput": `BusinessInformation_doubleInput__QjDwR`,
	"businessInformationCopy": `BusinessInformation_businessInformationCopy__fJ8CJ`
};
export default ___CSS_LOADER_EXPORT___;
